<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/platform/home-module-table'}">APP首页模块管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="moduleFormRules"
               label-width="120px"
               class="demo-ruleForm"
               @submit.native.prevent="onSubmit()">
        <el-form-item prop="type"
                      label="模块类型:">
          <el-select
            v-model="form.type"
            placeholder="请选择模块类型">
            <el-option
              v-for="item in options.moduleType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status"
                      label="模块状态:">
          <el-select
            v-model="form.status"
            placeholder="请选择模块状态">
            <el-option
              v-for="item in options.moduleState"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="badge_type"
                      label="角标类型:">
          <el-select
            v-model="form.badge_type"
            placeholder="请选择角标类型">
            <el-option
              v-for="item in options.badgeType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="badge_status"
                      label="角标状态:">
          <el-select
            v-model="form.badge_status"
            placeholder="请选择角标状态">
            <el-option
              v-for="item in options.badgeState"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="badge_start"
                      label="角标开始时间:">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"
                          v-model="form.badge_start"
                          type="datetime"
                          placeholder="请选择角标开始时间"
                          align="center">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="badge_end"
                      label="角标结束时间:">
          <el-date-picker v-model="form.badge_end"
                          type="datetime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="请选择角标结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">新建
          </el-button>
          <router-link :to="{ path: '/platform/home-module-table'}">
            <el-button>取消</el-button>
          </router-link>
        </el-form-item>
      </el-form>

    </layout-panel>

  </div>
</template>

<script>
import { makeRule } from '@core/utils/rule.js'

export default {
  data () {
    return {
      selectLoading: false,
      form: {},
      options: {
        moduleType: [{label: '福利社', value: 1}, {label: '小零商城', value: 2}, {label: '小零招聘', value: 3}],
        moduleState: [{label: '启用', value: 1}, {label: '不启用', value: 0}],
        badgeType: [{label: '上新角标', value: 1}],
        badgeState: [{label: '启用', value: 1}, {label: '不启用', value: 0}],
      },
      moduleFormRules: {
        type: [
          {...makeRule('请选择模块类型', 'integer')},
        ],
        status: [
          {...makeRule('请选择模块状态', 'integer')},
        ],
        badge_type: [
          {...makeRule('请选择角标类型', 'integer')},
        ],
        badge_status: [
          {...makeRule('请选择角标状态', 'integer')},
        ],
        badge_start: [
          {required: true, message: '角标开始时间不能为空', trigger: 'blur'},
        ],
        badge_end: [
          {required: true, message: '角标结束时间不能为空', trigger: 'blur'},
          {validator: this.endtimeValidator, trigger: 'blur'},
        ],
      },
      availableModule: [],
    }
  },
  computed: Vuex.mapState({}),
  created () {
    if (this.$route.query.module) {
      this.form = this.$route.query.module
    }
    this.getAvailableModule()
  },
  methods: {
    ...Vuex.mapActions({}),

    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let data = {
            id: this.form.id,
            type: this.form.type,
            status: this.form.status,
            badge_start: this.form.badge_start,
            badge_end: this.form.badge_end,
            badge_type: this.form.badge_type,
            badge_status: this.form.badge_status,
          }
          if (this.form.id === null || this.form.id === undefined) {
            return request.common('createModule', data).then((data) => {
              this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success',
              })
              this.$router.push({path: '/platform/home-module-table'})
            })
          } else {
            data.id = this.form.id
            return request.common('editModule', data).then((data) => {
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success',
              })
              this.$router.push({path: '/platform/home-module-table'})
            })
          }
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    getAvailableModule () {
      request.page('getAvailableModule').then((data) => {
        let moduleTypes = []
        data.data.forEach((module, index) => {
          let moduleType = {
            label: module.name,
            value: module.type,
          }
          moduleTypes.push(moduleType)
        })
        this.options.moduleType = moduleTypes
      })
    },
    // 验证活动结束时间
    endtimeValidator (rule, value, callback) {
      if (Date.parse(this.form.badge_end) <= Date.parse(this.form.badge_start)) {
        callback(new Error('角标结束时间必须晚于角标开始时间'))
      } else {
        callback()
      }
    },
  },

}
</script>
<style lang="scss"
       scoped>

</style>



// WEBPACK FOOTER //
// src/views/platform/pages/PlatformHomeModuleForm.vue